import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from "antd";

import { actions } from "store";
import { ArticleList, ArticleForm } from 'components/blocks/Article';


class ArticleListScreen extends Component {
  showForm = (item = null) => {
    const { actions } = this.props;
    actions.articleShowEditForm({ show: true, object: item });
  };

  render() {
    const { site, history } = this.props;
    const detail = site.detail;

    return (
      <Fragment>
        <div className="page-content page-content-full">
          <div className="page-block page-block-full">
            {detail &&
            <ArticleList
              history={history}
              activeFilter={{ site: detail.id }}
              topActions={[
                <Button type="primary" className="" icon="plus" onClick={() => this.showForm()}>
                  Добавить статью
                </Button>
              ]}
            />}
          </div>

          {detail &&
          <ArticleForm siteId={detail.id}/>}
        </div>
      </Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    site: state.site,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, actions.article), dispatch),
    dispatch: dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleListScreen);
